<template>
  <i-rack>
    <i-section>
      <div class="wrapper layout column fill-height">
        <div ref="entityContainer" class="py-2 px-4">
          <div class="layout align-center">
            <v-select
              slot="left"
              v-model="selected"
              :items="items"
              color="blue"
              class
              :no-data-text="emptyCollectionLabel"
              :label="`Select ${label}`"
              item-text="name"
              item-value="_id"
              hide-details
              solo
              flat
            >
              <template v-slot:item="{ item, index }">
                <span class="text--light-blue">{{ item.name }}</span>
              </template>
              <template v-slot:selection="{ item, index }">
                <span class="text--light-blue text-bold">{{ item.name }}</span>
              </template>
            </v-select>
            <v-spacer />
            <div slot="right" class="d-flex justify-center items-center">
              <v-btn
                v-if="active && active.slides && active.slides.length > 0"
                class="mr-2"
                icon
                color="primary"
                :loading="loading"
                @click="toPdf"
              >
                <v-icon>mdi-pdf-box</v-icon>
              </v-btn>
              <v-btn
                v-if="active && active.slides"
                class="mr-2"
                icon
                color="primary"
                :loading="loading"
                @click="e => deleteCollection(active._id)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>

              <v-btn
                v-if="active && active.slides && active.slides.length > 5"
                small
                icon
                color="primary"
                @click="moveLeft"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn
                v-if="active && active.slides && active.slides.length > 5"
                small
                icon
                color="primary"
                @click="moveRight"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <slot />
            </div>
          </div>
          <div class="layout px-4 mt-2 drop-box">
            <v-layout class="drop-box" row d-flex>
              <div
                v-if="!active || Object.entries(active).length === 0"
                class="empty-state-container absolute pt-12"
              >
                <div class="header">There is no {{ label }} selected</div>
                <div class="text text--darkest-grey">Please select a {{ label }} to get started.</div>
              </div>
              <!-- <div
                v-else-if="active && (!active.slides || active.slides.length === 0)"
                class="empty-state-container pt-12"
              >
                <div class="header">Add Slides by drag and drop</div>
                <div
                  class="text text--darkest-grey"
                >So far, you have no slides in your {{ label }}. It's time for you to add your first slide.</div>
              </div>-->
              <Container
                v-if="active && active.slides"
                ref="entityRow"
                :get-child-payload="getPayloadCollection"
                group-name="1"
                :style="ifNoSlidesStyle"
                :drop-placeholder="upperDropPlaceholderOptions"
                orientation="horizontal"
                drag-class="card-ghost"
                drop-class="card-ghost-drop"
                class="layout drop-box py-2 no-wrap scroll-x-auto"
                @drop="update"
              >
                <!-- <div
                  v-if="active && active.slides && active.slides.length === 0"
                  class="empty fill-height"
                />-->
                <Draggable v-for="(slide, index) in active.slides" :key="`${slide._id}${Date.now()}`">
                  <slide-card
                    dense
                    class="mr-2"
                    :item="slide"
                    style="max-height: 350px; max-width: 250px"
                    deletable
                    @delete="remove(slide, index)"
                  />
                </Draggable>
              </Container>
            </v-layout>
          </div>
        </div>
        <div class="w-full px-4 py-1">
          <v-divider />
        </div>
        <slide-filter-boundary v-if="slides" class="library px-4 pt-2 pb-2">
          <template v-slot:content>
            <div class="container px-0 pt-0 container--fluid grid grid-list-lg">
              <Container
                :get-child-payload="getPayload"
                behaviour="copy"
                group-name="1"
                class="layout wrap"
                :sort="false"
              >
                <Draggable v-for="id in slideIds" :key="id" class="md4 flex">
                  <slide-card dense :item="slideMap[id]" />
                </Draggable>
              </Container>
              <div v-show="slides.length < meta.countLibrary" id="hidden-target">
                <v-btn text small @click="shiftLimit">Load more..</v-btn>
              </div>
            </div>
          </template>
        </slide-filter-boundary>
      </div>
    </i-section>
    <i-section v-if="slides" :scrollable="true" :width="300" class="fixed border-left">
      <slides-filter :show="true" :number-items="slides.length" />
    </i-section>
  </i-rack>
</template>
<script>
import draggable from 'vuedraggable';
import { Container, Draggable } from 'vue-smooth-dnd';
import TitleComponent from '../core/title-component';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import SlideCard from '../cards/slide-card';
import SlidesFilter from '@/components/drawer/FilterComponent';
import SlideFilterBoundary from '@/hoc/SlideFilterBoundary';
import LoadingVue from '@/components/core/animations/loading-animation';
import { confirm } from '../../utils/modal';
const options = {
  root: null,
  threshold: 1,
  rootMargin: '0px'
};

export default {
  components: {
    SlideCard,
    TitleComponent,
    draggable,
    SlidesFilter,
    Container,
    Draggable,
    SlideFilterBoundary,
    loading: LoadingVue
  },
  props: {
    active: {
      type: Object,
      required: false,
      default: () => null
    },
    items: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    emptyCollectionLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      selected: this.active._id,
      payload: null,
      upperDropPlaceholderOptions: {
        className: 'cards-drop-preview',
        animationDuration: '150',
        showOnTop: true
      }
    };
  },
  computed: {
    ifNoSlidesStyle() {
      if (this.active && this.active.slides && this.active.slides.length === 0) {
        return {
          backgroundColor: 'rgba(0,0,0,.04)',
          border: '1px dashed rgba(0,0,0,.12)'
        };
      }
    },
    ...mapState('library', {
      meta: state => state.meta,
      slideMap: state => state.map,
      slideIds: state => state.items,
      itemsInMap: state => state.itemsInMap
    }),
    ...mapGetters('library', {
      slides: 'getItems'
    })
  },
  mounted() {
    this.$store.commit('filter/resetFilter');
  },
  watch: {
    active: {
      handler: function(i) {
        if (i) {
          this.selected = i._id;
        }
      }
    },
    selected: {
      handler: function() {
        this.$emit('selected', this.selected);
      },
      immediate: true
    }
  },
  mounted() {
    if (this.active) {
      this.selected = this.active._id;
    }
    this.$store.dispatch('filter/filterSlides');
    this.observer = new IntersectionObserver(this.updateLimit, options);
    this.observer.observe(document.querySelector('#hidden-target'));
  },
  methods: {
    ...mapMutations({
      shiftLimit: 'filter/shiftLimit'
    }),
    updateLimit(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.shiftLimit();
        }
      });
    },
    update(event, item) {
      if (event.removedIndex !== null) {
        this.$emit('sort', {
          collection: this.active._id,
          slide: event.payload._id,
          oldPos: event.removedIndex,
          newPos: event.addedIndex
        });
      } else {
        this.$emit('update', {
          collection: this.active._id,
          slide: event.payload._id,
          pos: event.addedIndex
        });
      }
    },
    getPayload(index) {
      return this.slideMap[this.slideIds[index]];
    },
    getPayloadCollection(index) {
      return this.active.slides[index];
    },
    remove(slide, index) {
      this.$emit('delete', {
        collection: this.active._id,
        slide: slide._id,
        pos: index
      });
    },
    deleteCollection(id) {
      confirm('Delete Collection', 'Are you sure that you want to delete this collection?', 'Yes', 'No').then(
        yes => {
          if (yes) {
            this.$emit('delete-collection', {
              id: this.active._id
            });
          }
        }
      );
    },

    moveRight() {
      const child = this.$refs.entityRow.$children[0];

      if (child) {
        const offset = child.$el.clientWidth;
        this.$refs.entityRow.$el.scrollLeft += offset;
      }
    },
    moveLeft() {
      const child = this.$refs.entityRow.$children[0];
      if (child) {
        const offset = child.$el.clientWidth;
        this.$refs.entityRow.$el.scrollLeft -= offset;
      }
    },
    moveSlide() {
      const { height, width } = this.getSlideProportion();
      document.getElementsByClassName('sortable-chosen')[0].style.height = `${height}px`;
      document.getElementsByClassName('sortable-chosen')[0].style.width = `${width}px`;

      return true;
    },
    getSlideProportion() {
      if (this.$refs.entityRow && this.$refs.entityRow.$children.length > 0) {
        const child = this.$refs.entityRow.$children[0];
        if (child) {
          const height = child.$el.clientHeight;
          const width = child.$el.clientWidth;
          return { height, width };
        }
      }

      return { height: 200, width: 200 };
    },
    async toPdf() {
      this.$emit('pdf', this.active);
    }
  }
};
</script>
<style>
.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
<style lang="scss" scoped>
@import '@/assets/colors.scss';
.library {
  overflow-y: scroll;
}
.empty {
  width: 100%;
}
.drop-box {
  min-height: 200px;
  width: 100%;
  display: inline-flex !important;
  position: relative;
}
.border-dashed {
  border-color: $dark-grey;
  border-style: dashed;
}
.text {
  width: 400px;
  margin: 0 auto;
}
.border-left {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}
.header {
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}
.empty-state-container {
  text-align: center;
  margin: 0px auto;
  width: 100%;
}
.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  // margin: 5px 45px 5px 5px;
}
.text-bold {
  font-weight: bold;
}
</style>
